var _excluded = ["meta"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import React from 'react';
import { connect } from 'react-redux';
import { Button, FormModal, GRAY, Field, SubmitButton, useFormValue } from '@applyboard/ui-components';
import { DropdownField } from "../../../components/DropdownField";
import { TextAreaField } from "../../../components/TextAreaField";
import { useApplicationCancellationReasons } from "../../../data/applicationCancellationReasons";
import raiseErrorMessage from "../../../util/raiseErrorMessage";
import raiseSuccessMessage from "../../../util/raiseSuccessMessage";
import { applicationSetStatusAction, applicationSetCancellationReasonAction, applicationSetCancellationAdditionalNoteAction, applicationSetMetaAction } from "../../../store/actions/application";
import { useEventTracker } from '@applyboard/ui-utils';
var CancelApplicationModal = function CancelApplicationModal(props) {
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  var _useApplicationCancel = useApplicationCancellationReasons(),
    applicationCancellationReasons = _useApplicationCancel.applicationCancellationReasons;
  return /*#__PURE__*/React.createElement(FormModal, {
    title: "Cancellation Confirmation",
    open: props === null || props === void 0 ? void 0 : props.open,
    handleClose: props === null || props === void 0 ? void 0 : props.onClose,
    onSubmit: function onSubmit(_ref) {
      var _applicationCancellat, _applicationCancellat2;
      var cancelReason = _ref.cancelReason,
        cancelNote = _ref.cancelNote;
      var cancelReasonLabel = (_applicationCancellat = (_applicationCancellat2 = applicationCancellationReasons.find(function (reason) {
        return reason.id === cancelReason;
      })) === null || _applicationCancellat2 === void 0 ? void 0 : _applicationCancellat2.label) !== null && _applicationCancellat !== void 0 ? _applicationCancellat : '';
      props.cancelApplication({
        applicationId: props.applicationId,
        cancelReasonId: cancelReason,
        cancelReasonLabel: cancelReasonLabel,
        cancelNote: cancelNote !== null && cancelNote !== void 0 ? cancelNote : ''
      }, {
        onSuccess: function onSuccess(_ref2) {
          var response = _ref2.response;
          trackEvent({
            event: 'Single Application - Action Menu - Cancel Application - Clicked Submit'
          });
          raiseSuccessMessage("Application #".concat(props.applicationId, " has been cancelled."));
          props === null || props === void 0 ? void 0 : props.cancelApplicationAction({
            dataResponse: response.data,
            cancelReasonId: cancelReason,
            cancelReasonLabel: cancelReasonLabel,
            cancelNote: cancelNote
          });
          props === null || props === void 0 ? void 0 : props.onSuccess();
        },
        onError: function onError(err) {
          if (err instanceof Error) {
            raiseErrorMessage(err.message);
          }
        }
      });
    },
    footerButtons: function footerButtons() {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
        onClick: props === null || props === void 0 ? void 0 : props.onClose,
        style: {
          borderTop: "1px solid ".concat(GRAY[18])
        },
        variant: "text",
        color: "secondary"
      }, "CANCEL"), /*#__PURE__*/React.createElement(SubmitButton, {
        as: Button,
        loading: props.isCancellingApplication,
        disabled: props.isCancellingApplication,
        type: "submit"
      }, "CONFIRM"));
    }
  }, /*#__PURE__*/React.createElement(CancelForm, {
    applicationCancellationReasons: applicationCancellationReasons
  }));
};
var CancelForm = function CancelForm(_ref3) {
  var applicationCancellationReasons = _ref3.applicationCancellationReasons;
  var cancelReason = useFormValue('cancelReason');
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Field, {
    as: DropdownField,
    name: "cancelReason",
    label: "Reason for Cancellation",
    options: applicationCancellationReasons.map(function (reason) {
      return {
        label: reason.label,
        value: reason.id
      };
    }),
    mb: 3,
    required: true
  }), /*#__PURE__*/React.createElement(Field, {
    as: TextAreaField,
    name: "cancelNote",
    label: "Comment",
    mb: 2,
    required: cancelReason === 18 // 'Other' reason
    ,
    helper: "The maximum length of a text message is 500 characters.",
    maxLength: 500
  }));
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    cancelApplicationAction: function cancelApplicationAction(_ref4) {
      var dataResponse = _ref4.dataResponse,
        cancelReasonId = _ref4.cancelReasonId,
        cancelReasonLabel = _ref4.cancelReasonLabel,
        cancelNote = _ref4.cancelNote;
      var meta = dataResponse.meta,
        statusResponse = _objectWithoutProperties(dataResponse, _excluded);
      dispatch(applicationSetStatusAction(statusResponse));
      dispatch(applicationSetCancellationReasonAction({
        cancelReasonId: cancelReasonId,
        cancelReasonLabel: cancelReasonLabel
      }));
      dispatch(applicationSetCancellationAdditionalNoteAction(cancelNote));
      dispatch(applicationSetMetaAction(meta || {}));
    }
  };
};
export default connect(null, mapDispatchToProps)(CancelApplicationModal);